import React, { useState } from "react";
import { Card, Form, Input, Button, message } from "antd";
import API from '../api';
import { useDispatch } from 'react-redux';
import { setUser } from '../redux/slices/authSlice';
import Spinner from "../components/Spinner";
import './Login.css';

const Login = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await API.post('/auth/login', values);
      if (response.status === 200) {
        message.success("Login Successful.");
      }
      const { user, token } = response.data;
      localStorage.setItem('tokenData', JSON.stringify(token));
      localStorage.setItem('userData', JSON.stringify(user));
      dispatch(setUser(user));
      window.location.href = "/";
    } catch (err) {
      message.error(err?.response?.data?.message || 'Invalid credentials, please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-left-section" />
      <div className="login-right-section">
        <Card className="login-card">
          <div className="login-header">
            <img src="/logo.jpeg" alt="Logo" className="login-logo" />
            <h1 className="login-title">Welcome Back!</h1>
            <p className="login-subtitle">Please sign in to continue</p>
      </div>
          <Form 
            name="login" 
            onFinish={onFinish} 
            className="login-form"
            layout="vertical"
            size="large"
          >
            <Form.Item
              name="email"
              rules={[
                { required: true, message: "Please input your email!" },
                { type: 'email', message: 'Please enter a valid email!' }
              ]}
            >
              <Input 
                placeholder="Email" 
                size="large"
                prefix={<span style={{ color: '#bfbfbf' }}>📧</span>}
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[{ required: true, message: "Please input your password!" }]}
            >
              <Input.Password 
                placeholder="Password" 
                size="large"
                prefix={<span style={{ color: '#bfbfbf' }}>🔒</span>}
              />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                block
                className="login-button"
                loading={loading}
              >
                {loading ? <Spinner size={20} color={'white'} /> : 'Sign In'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default Login;
